"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementName = void 0;
var AchievementName;
(function (AchievementName) {
    AchievementName["PERFECT_LEVEL_1"] = "perfectLevel1";
    AchievementName["PERFECT_LEVEL_2"] = "perfectLevel2";
    AchievementName["PERFECT_GAME"] = "perfectGame";
    AchievementName["FINISH_ALL_LEVELS"] = "finishAllLevels";
    AchievementName["FIVE_FIRST_TRIES"] = "fiveFirstTries";
})(AchievementName = exports.AchievementName || (exports.AchievementName = {}));
//# sourceMappingURL=AchievementName.js.map